<div class="flex dark:text-gray-100 dark:bg-transparent">
  <div class="estilo-dark dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
    <label for="#id_tranportista" class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent">Transportista</label>
    <select class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" name="" id="id_tranportista" (change)="consultarConvenionios($event)">
      <option [value]="0">Selecciona un transportista</option>
      <option *ngFor="let transportista of dataTransportistas" [value]="transportista.id">{{transportista.transportista}}</option>
    </select>
  </div>
  <div class="estilo-dark dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
    <label for="#convenio" class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent">Mon. Exentos</label>
    <select  class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" name="" id="convenio" (change)="seleccionarConvenio($event)">
      <option [value]="0">Selecciona una opción</option>
      <option *ngFor="let convenio of convenios" [value]="convenio.id">{{convenio.fecha_inicio | date: 'dd/MM/yyyy' }}-{{convenio.fecha_cierre | date: 'dd/MM/yyyy' }} ${{convenio.saldo}}</option>
    </select>
  </div>
  <div class=" estilo-dark dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
    <div class="w-full text-center estilo-dark dark:text-gray-100 dark:bg-transparent">Saldo a favor</div>

    <div class="w-100 estilo-dark dark:text-gray-100 dark:bg-transparent">
      <div class="text-right w-auto flex w-full border-b-2"><div class="text-left w-10 flex mr-auto">$</div><div class="text-left ml-auto">{{ saldo}}</div></div>
    </div>
  </div>
</div>


<form  class="row">
    <div class="dark:text-gray-100 dark:bg-transparent align-middle flex"  style="width: 25%;" *ngFor="let tarifa of dataTarifas">
      <span class="w-2/3 text-right ml-auto inline-block align-middle pt-5 mr-3">{{tarifa.vehiculo.tipo}}</span>
      <input  type="number" class="w-1/3 flex text-left estilo-dark dark:text-gray-100 dark:bg-gray-700 ml-auto clasificacionesBoletaje" (change)="incrementarBoletos(tarifa.id, tarifa.monto,$event); insertBoleto($event, tarifa)" min="0" value="0" step="1" >
    </div>
    <hr>

    <div class="w-full grid grid-cols-3 grid-flow-col gap-4">
          <span class="col-span-2 ml-auto inline-block align-middle pt-5 dark:text-gray-100">Total</span>
          <div class="text-left border-b-2 estilo-dark dark:text-gray-100 dark:bg-gray-700">{{total}}</div>
    </div>

    <div class="items-end flex" *ngIf="operacionValida">
      <button class="flex estilo-dark dark:bg-transparent dark:text-white dark:hover:border-blue-600 hover:border-blue-600" (click)="saveBoletos()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"  >
          <path stroke-linecap="round" stroke-linejoin="round" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
        </svg>
        <span class="ml-2">
          Guardar
        </span>
      </button>
      <!-- <button class="flex estilo-dark dark:bg-transparent dark:text-white dark:hover:border-blue-600 hover:border-blue-600">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
        </svg>
        <span class="ml-2">
          Imprimir
        </span>
      </button>
      <button class="flex estilo-dark dark:bg-transparent dark:text-white dark:hover:border-blue-600 hover:border-blue-600">
        <svg class="h-5 w-5" fill="none" viewBox="0 0 32 32" stroke="currentColor" stroke-width="2">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path d="M23,15c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S27.4,15,23,15z M26.7,23.8c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.5-0.1-0.7-0.3 L24,22.5V27c0,0.6-0.4,1-1,1s-1-0.4-1-1v-4.5l-1.3,1.3c-0.4,0.4-1,0.4-1.4,0c-0.4-0.4-0.4-1,0-1.4l3-3.1c0,0,0,0,0,0 c0.2-0.2,0.4-0.3,0.7-0.3s0.5,0.1,0.7,0.3c0,0,0,0,0,0l3,3.1C27.1,22.8,27.1,23.4,26.7,23.8z"></path>
            <path d="M13,23c0-1.4,0.3-2.8,0.9-4c-0.2,0-0.4-0.1-0.5-0.2l-1.6-1.4l-5.1,4.4C6.5,21.9,6.2,22,6,22c-0.3,0-0.6-0.1-0.8-0.3 c-0.4-0.4-0.3-1,0.1-1.4l4.9-4.2l-4.9-4.2c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l7.3,6.4l7.3-6.4c0.4-0.4,1-0.3,1.4,0.1 c0.4,0.4,0.3,1-0.1,1.4L21,13.2c0.6-0.1,1.3-0.2,2-0.2c1.4,0,2.8,0.3,4,0.8V9c0-1.7-1.3-3-3-3H4C2.3,6,1,7.3,1,9v14c0,1.7,1.3,3,3,3 h9.5C13.2,25.1,13,24,13,23z"></path>
          </g>
        </svg>
        <span class="ml-2">
          Enviar por correo
        </span>

      </button> -->
    </div>
</form>

